/**
* @name APP u-suite
* @autor over.martinez@u-planner.com
* @description
* Descripcion del controlador
* @controller 
* # name: loginErrorMessage
* # alias: $ctrl
*/

export default class loginErrorMessage {

	constructor($rootScope, $scope, $state, $stateParams, ngNotify, uFunctions, LOCAL_ENV_CONSTANT, $cookies, $localStorage, $timeout) {
		this.$rootScope = $rootScope
		this.$cookies = $cookies
		this.$state = $state
		this.$localStorage = $localStorage
		this.$timeout = $timeout
		this.$scope = $scope
		this.config = LOCAL_ENV_CONSTANT
		this.$stateParams = $stateParams
		this.ngNotify = ngNotify
		this.Helpers = uFunctions
		this.main()
	}

	main() {
		this.message = this.Helpers.getUserStored(this.$stateParams.message)
	}

	goToLoggin() {
		const auth = this.Helpers.getUserStored()
		const id = auth ? auth.user.id : 0
		const url = this.config.USER_API_URL + '/api/user-api'
		let auth2

		try {
			// eslint-disable-next-line no-undef
			gapi.auth2.init()
			// eslint-disable-next-line no-undef
			auth2 = gapi.auth2.getAuthInstance()
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('error->', error)
		}
		delete this.$localStorage.userLogin
		delete this.$localStorage.userAuth
		this.$cookies.put('hasDemand', '')
		this.$cookies.remove('isAdmin')
		this.$cookies.remove('hasType')

		if (this.config.loginType == 'web') {
			if (auth2 && auth2.isSignedIn.get()) {
				auth2.disconnect().then(function () {
					window.location.href = '/login'
				})
			} else {
				window.location.href = '/login'
			}
		} else {
			let iframe = document.createElement('iframe')

			iframe.style.display = 'none'
			iframe.src = `${url}/logout?id=${id}`
			document.body.appendChild(iframe)

			this.$timeout(function () {
				window.location = 'app/home'
			}, 3000)
		}
	}

}

loginErrorMessage.$inject = [ '$rootScope', '$scope', '$state', '$stateParams', 'ngNotify', 'uFunctions', 'LOCAL_ENV_CONSTANT', '$cookies', '$localStorage', '$timeout' ]



// WEBPACK FOOTER //
// ./src/login/loginErrorMessageController.js